<div>
  <div class="payment-card mat-elevation-z0 border-card cir-border">
    <div *ngIf="!isWebView">
      <div class="row-with-space">
        <div class="row-without-space">
          <div class="card-type">
            <p class="font-16 font-weight-600 grey-color text-center-align margin-bottom-zero">
              {{ paymentCard.cc_type?.toUpperCase() }}
            </p>
          </div>
          <div class="card-suffix">
            <p class="margin-bottom-zero black-color font-14">
              **** **** **** {{ paymentCard.suffix }}
            </p>
          </div>
        </div>
        <div class="row-without-space">
          <!-- <p class="font-16 grey-color">Default</p> -->
          <div *ngIf="paymentCard.payment_method_no === defaultPaymentMethodNo">
            <p class="margin-bottom-zero margin-left-6 margin-top-4 font-16 grey-color">Default</p>
          </div>
        </div>
      </div>
      <span class="card-data-padding font-12 text-wrap black-color">
        Exp
        {{ paymentCard.cc_expire_mm + "/" + paymentCard.cc_expire_yyyy }}
      </span>
      <div class="card-user-margin-top card-data-padding colum-without-spaces">
        <div class="row-with-space">
          <div>
            <p class="font-14 black-color">
              {{ paymentCard.bill_first_name + " " + paymentCard.bill_last_name }}
            </p>
          </div>
        </div>
        <div class="row-with-space">
          <div>
            <p class="font-14 billing-text black-color">
              Billing Address: <span class="">{{ paymentCard.bill_address1 }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isWebView">
      <div class="card-data-padding-wv">
        <div class="flex-row">
          <div class="row-without-space-wv">
            <div class="card-type">
              <p class="font-14 font-weight-600 text-color text-center-align margin-bottom-3px">
                {{ paymentCard.cc_type?.toUpperCase() }}
              </p>
            </div>
            <div class="card-suffix">
              <p class="margin-bottom-3px font-weight-600 font-14 text-color">
                * {{ paymentCard.suffix }}
              </p>
            </div>
          </div>
          <div class="default-class margin-left-6 margin-top-4 font-12 text-color"
            *ngIf="paymentCard.payment_method_no === defaultPaymentMethodNo">
            Default
          </div>
        </div>

        <div class="font-12 text-wrap text-color">
          Exp
          {{ paymentCard.cc_expire_mm + "/" + paymentCard.cc_expire_yyyy }}
        </div>
      </div>

      <div class="card-user-margin-top-wv card-data-padding-wv colum-without-spaces">
        <div class="row-with-space">
          <div>
            <p class="font-15 margin-bottom-3px text-color">
              {{ paymentCard.bill_first_name + " " + paymentCard.bill_last_name }}
            </p>
          </div>
        </div>
        <div class="row-with-space ">
          <p class="font-12 billing-text margin-bottom-3px text-color">
            Billing Address: <span class="">{{ paymentCard.bill_address1 }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="card-options">
    <div class="{{isWebView ? 'card-webview' : 'set-default'}}">
      <p *ngIf="paymentCard.payment_method_no !== defaultPaymentMethodNo" class="font-14"
        (click)="onClickSetDefault(paymentCard)">Set Default
      </p>
    </div>
    <div class="{{isWebView ? 'card-webview' : 'remove-card' }}">
      <p class="font-14" (click)="onClickRemove(paymentCard)">Remove Card</p>
    </div>
  </div>
</div>
